<template>
    <a class="view-details-banner" href="#" v-scroll-to="'#' + scrollToId" @click="viewDetails">
        <x-icon color="teal" class="mr-2">report</x-icon>
        <p>{{ text }}
            Click here to view {{ subject }}.
        </p>
    </a>
</template>

<script>
export default {
    name: "ViewDetailsBanner",
    props: {
        text: {
            type: String,
            required: true
        },
        scrollToId: {
            type: String,
            required: false,
            default: ''
        },
        subject: {
            type: String,
            required: false,
            default: 'details'
        },
    },
    methods: {
        viewDetails() {
            this.$emit('clicked');
        },
    }
}
</script>

<style scoped lang="scss">
.view-details-banner {
    display: flex;
    background: rgba(124, 224, 211, 0.2);
    border: 1px solid $color-teal;
    border-radius: $border-radius;
    padding: 12px 16px;
    color: $color-teal;
    font-size: rem(14px);
    font-weight: 600;
    text-decoration: none;

    .x-icon {
        font-size: rem(17px);
    }
}
</style>
